import React, { useState } from 'react';
import { isMobile } from '@tv2/lib-offspring/libs/isMobile';
import Watermark from '@tv2/lib-offspring/components/watermark/Watermark';
import { Link } from '../../../../Link';
import { CardAction } from '../actions/CardAction';
import { MiniHeroContent } from '../MiniHeroContent';
import { MiniHeroImage } from '../MiniHeroImage';
import { CardProps, VodCardButton } from './VodCard';

export function VodCardMiniHero({ card, actions }: CardProps): React.ReactNode {
  const [showOverlay, setShowOverlay] = useState(false);

  const hasCardActions = Boolean(card.actions && card.actions.length > 0);
  const showActionsOverlay = showOverlay && hasCardActions;
  const hasButton = Boolean(card.button);

  return (
    <div key={card.id}>
      <Link destination={card.destination} action={card.action} onAction={actions}>
        <div
          onClick={() => {
            if (isMobile()) {
              setShowOverlay(x => !x);
            }
          }}
          onMouseEnter={e => {
            if (isMobile()) {
              e.preventDefault();
              return;
            }
            setShowOverlay(true);
          }}
          onMouseLeave={e => {
            if (isMobile()) {
              e.preventDefault();
              return;
            }
            setShowOverlay(false);
          }}
          className="relative hover:scale-s 2xl:hover:scale-xs transition-transform pb-1"
          {...(card.title ? { 'aria-label': card.title } : {})}
        >
          <div className="relative w-full overflow-hidden">
            <MiniHeroImage
              mobileImageUrl={card.mobileImageUrl}
              tabletImageUrl={card.tabletImageUrl}
              desktopImageUrl={card.desktopImageUrl}
              alt={card.title ?? ''}
            />

            {card.logoUrl ? (
              <Watermark alt={card.title ?? ''} title={card.title ?? ''} src={card.logoUrl} />
            ) : null}

            {showActionsOverlay ? (
              <div className="absolute right-2 top-2 z-[3] flex flex-col items-end gap-1">
                {card.actions.map((action, index) => (
                  <CardAction key={index} cardAction={action} actions={actions} />
                ))}
              </div>
            ) : null}

            <MiniHeroContent
              labels={card.labels}
              title={card.title}
              subTitle={card.subTitle}
              cta={
                hasButton ? (
                  <VodCardButton card={card} active={showOverlay} variant="inline" />
                ) : null
              }
            />
          </div>
        </div>
      </Link>
    </div>
  );
}
